<template>
  <TextField :label="$tt('passport_number')" :rules="[required]" />
</template>

<script setup lang="ts">
const { required } = useValidation();
</script>